'use client';

import AuthForm from '@/components/auth/auth-form';
import { amplifyConfig } from '@/lib/constants';
import { Amplify } from 'aws-amplify';

Amplify.configure(amplifyConfig);

export default function AuthPage() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
            <AuthForm />
        </div>
    );
}
